@if(this.init){
    <div class="demooz_input_phone"
        [class.no_margin]="this.noMargin"
        [class.disabled]="this.disabled"
        [class.text_left]="this.textAlign === 'left'"
        [class.text_center]="this.textAlign === 'center'"
        [class.text_right]="this.textAlign === 'right'"
        >

        @if(this.iconInput !== ''){
            <ion-icon class="demooz_input_phone_icon_prefix" [name]="this.iconInput"></ion-icon>
        }

        @if(this.isRequired){
            <div class="demooz_input_phone_required">*</div>
        }

        @if(this.fixedLabel){
            <div class="demooz_input_phone_fixed_label" (click)="this.focusInput()">{{this.labelInput}}</div>
        }


        <intl-tel-input       
            #demoozInput
            [formControlName]="this.formName"
            [initOptions]="this.initOptions"
            (validityChange)="this.onValidityChange($event)"
          />

        @if(this.showBtnClearInput 
            && this.formGroupDirective.form.controls[this.formName] 
            && this.formGroupDirective.form.controls[this.formName].value 
            && this.formGroupDirective.form.controls[this.formName].value != '' ){
            <ion-icon class="demooz_input_phone_icon_sufix" name="close-circle-outline" (click)="this.clearInput()"></ion-icon>
        }

    </div>

    @if(this.errorTextNumberValidation !== '' 
        && this.formGroupDirective.form.controls[this.formName] 
        && this.formGroupDirective.form.controls[this.formName].touched 
        && this.formGroupDirective.form.controls[this.formName].errors){
        <div class="demooz_input_phone_error">{{this.errorTextNumberValidation}}</div>
    }
}